// Limit the sentence up until 30 words & added dots for more info.
export default (description: string) => {
    return description.split(' ').slice(0, 30).join(' ') + '...';
};
